// extracted by mini-css-extract-plugin
module.exports = {"xstream_A":"A_xstream_A__DhC4V"};